<div class="row no-gutters vessel-visit-container">
	<div [ngClass]="collapsedVesselAndNOA()?'col-3':'col-12'"
		 class="noa__card ">
		<div class="noa__flex flex-wrap">
			<!-- <button kendoButton
					[icon]="'arrow-chevron-left'"
					[fillMode]="'clear'"
					[size]="'small'"
					(click)="goBack()">
			</button> -->
			<div class="font-size-20 d-flex">
				<b>Visit (Ref {{ vesselVisit()?.id }})</b>
				<button kendoButton
						*ngIf="collapsedVesselAndNOA()"
						class="transparent-icon-button mx-2"
						(click)="onEdit()">
					<kendo-icon name="pencil"></kendo-icon>
				</button>
			</div>
			<!-- <div class="noa__flex"> -->
			<!-- <kendo-dropdownlist [data]="mockStatus"
									[value]="vesselVisitState()"
									(valueChange)="vesselVisitState.set($event)"
									[fillMode]="'none'"
									[rounded]="'full'"
									[size]="'small'"
									[ngClass]="vesselVisitStatusColour(vesselVisitState())">
					<ng-template kendoDropDownListValueTemplate
								 let-dataItem>
						<span class="text-uppercase">STATUS:&nbsp;<b>{{ dataItem }}</b></span>
					</ng-template>
				</kendo-dropdownlist> -->

			<!-- <kendo-chip [fillMode]="'none'"
							[rounded]="'full'"
							[removable]="false"
							[selected]="false"
							[ngClass]="vesselVisitStatusColour(vesselVisitState())"
							class="pointer-events-none">
					<span class="noa__chip-text">STATUS:&nbsp;<b>{{vesselVisitState()}}</b></span>
				</kendo-chip> -->

			<!-- <kendo-chip [fillMode]="'none'"
							[rounded]="'full'"
							[removable]="false"
							[selected]="false"
							class="bg-blue pointer-events-none">
					<span class="noa__chip-text">Remarks</span>
				</kendo-chip> -->
			<!-- </div> -->
		</div>
		<div [ngClass]="{'d-none':!collapsedVesselAndNOA()}"
			 class="w-100 mt-2">
			<kendo-tabstrip (tabSelect)="onTabSelect($event)"
							class="k-tabstrip-no-content">
				<kendo-tabstrip-tab title="Vessel Information"
									[selected]="activeTabIndex() === 0"></kendo-tabstrip-tab>
				<kendo-tabstrip-tab title="Visit Information"
									[selected]="activeTabIndex() === 1"></kendo-tabstrip-tab>
			</kendo-tabstrip>
		</div>
		<div class="row">
			<!-- Vessel component -->
			<pmis3-vessel-visit-detail-vessel [collapsed]="collapsedVesselAndNOA()"
											  [class.d-none]="collapsedVesselAndNOA() && activeTabIndex() !== 0"
											  [ngClass]="collapsedVesselAndNOA()? 'col-12' : 'col-6'">
			</pmis3-vessel-visit-detail-vessel>

			<!-- NOA component -->
			<pmis3-vessel-visit-detail-noa [collapsed]="collapsedVesselAndNOA()"
										   [class.d-none]="collapsedVesselAndNOA() && activeTabIndex() !== 1"
										   [ngClass]="collapsedVesselAndNOA()? 'col-12' : 'col-6'"
										   [seaports]="seaports()"
										   (allFieldsValidChange)="allVisitFieldsValid.set($event)">
			</pmis3-vessel-visit-detail-noa>
		</div>
	</div>
	@if (collapsedVesselAndNOA()) {
	<div class="col pl-2">
		<div class="row no-gutters flex-column h-100">
			<div class="noa__card"
				 style="margin-bottom:10px;">
				<div style="padding-bottom:10px;">
					<b class="font-size-20"
					   style="margin-right:10px;">Movement(s)</b>
					<span>Add movement for {{ selectedVessel()?.name }}</span>
				</div>
				<div class="bg-gray-lighter border-radius-15 stepper-container"
					 style="padding:15px;">
					<pmis3-vessel-visit-stepper *ngIf="vesselVisit()"
												[disabled]="!allActivityFieldsValid()"
												[vesselVisit]="vesselVisit()"></pmis3-vessel-visit-stepper>
				</div>
			</div>
			<div class="col noa__card overflow-auto">
				<!-- <h3 class="px-4 my-2 font-weight-bolder">{{ shortCodeOfSelectedStop() }} </h3> -->
				@if (groupedIndicesForEditingVesselActivities().length > 0) {
				<pmis3-vessel-visit-detail-movement (allFieldsValidChange)="allActivityFieldsValid.set($event)">
				</pmis3-vessel-visit-detail-movement>
				}


				<!-- @for (pair of pairedVesselActivitiesSignals(); let i = $index; track i) {
				@if (renderVesselPairDetails(pair())) {
				<div class="d-flex align-items-center py-2 px-3" style="gap:8px;">
					<div class="stop-number">{{ getStopNumberFromIndex(i) }}</div>
					<h3 class="m-0">{{ getStopTypeFromIndex(i) }}</h3>
					<div class="d-flex">
						<kendo-chip [fillMode]="'none'" [rounded]="'full'" [removable]="false" [selected]="false"
							[size]="'small'" class="pointer-events-none bg-green font-size-10">
							<span class="text-uppercase line-height-1">VFPA</span>
						</kendo-chip>
					</div>
					<div class="ml-auto">
						<div
							class="d-inline-flex align-items-center border px-3 py-1 border-radius-15 border-blue text-blue">
							<button kendoButton icon="trash" class="withdraw" (click)="withdrawPair(i)">
								<span class="text-blue">WITHDRAW MOVEMENT</span>
							</button>
						</div>
					</div>
				</div>

				<pmis3-vessel-visit-detail-movement [vesselActivitiesPair]="pair()"
					(vesselActivitiesPairChange)="onVesselActivitiesPairChange(i, $event)"></pmis3-vessel-visit-detail-movement>
				}


				} -->
			</div>
		</div>
	</div>
	}
</div>
<div class="noa__card text-right"
	 style="margin-top:10px; padding-top:6px; padding-bottom:6px;">
	<kendo-buttongroup class="w-button-group-horizontal">
		<button kendoButton
				*ngIf="collapsedVesselAndNOA()"
				(click)="onSaveNOA()"
				[disabled]="NOADisabled()"
				[themeColor]="'primary'">
			Save
		</button>
		<button kendoButton
				*ngIf="collapsedVesselAndNOA()"
				(click)="onSubmitNOA()"
				[disabled]="NOADisabled()"
				[themeColor]="'primary'">
			Save and Submit
		</button>
		<button kendoButton
				*ngIf="!collapsedVesselAndNOA()"
				(click)="addMovements()"
				[disabled]="!allVisitFieldsValid()"
				[themeColor]="'primary'">
			Add Movements
		</button>
		<button kendoButton
				[fillMode]="'outline'"
				[themeColor]="'primary'"
				(click)="goBack()">
			Close
		</button>
	</kendo-buttongroup>
</div>